<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import io from "socket.io-client";
import User from "@/services/Users";
import isEmpty from "@/outils/isEmpty";
import router from "@/routes";
import Node from "./services/NodeData";
export default {
  name: "App",

  components: {
    // HelloWorld,
  },

  data: () => ({
   // socket: null
  }),
  created() {
   
    if (isEmpty(localStorage.getItem("authToken"))) router.push("/login");
    else {
      this.$store.state.tk = localStorage.getItem("authToken");
      if (this.$store.commit("checktoken") == false) router.push("/login");
    }
  },
};
</script>

<style scoped>
.y {
  width: 100%;
  height: 100%;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("./assets/img/Data-Field.jpg");
}
.y background-image {
  filter: blur(4px);
}
</style>
